import { AuthError, isRecord, isUuid } from './http'

export const paymentMessages = {
  ALIPAY_NOT_CONFIGURED: '支付宝收款尚未开通，请选择微信支付。',
  ALIPAY_CONFIG_UNAVAILABLE: '支付宝收款配置异常，请联系客服处理。',
  ALIPAY_PERMISSION_DENIED: '支付宝订单码支付暂不可用，请联系客服处理。',
  ALIPAY_RESPONSE_UNVERIFIED: '暂时无法验证支付宝支付结果，如已付款请勿重复支付。',
  ALIPAY_STATUS_UNKNOWN: '支付宝支付状态暂未确认，请稍后查询，不要重复付款。',
  WECHAT_PAYMENT_NOT_CONFIGURED: '微信充值暂未开放，请稍后再试。',
  WECHAT_PAYMENT_CHANNEL_DISABLED: '当前设备的微信支付方式尚未开通，请联系管理员。',
  PAYMENT_CHANNEL_MISMATCH: '此订单在另一种支付方式下创建，请回到原设备付款；也可先关闭该订单，再在当前设备重新下单。',
  PAYMENT_SITE_MISMATCH: '支付域名配置与当前网站不一致，请联系管理员。',
  PAYMENT_OAUTH_CONFIG_ERROR: '微信内支付的公众号配置异常，请联系管理员。',
  PAYMENT_AUTH_FAILED: '微信支付授权未完成，请点击继续支付重试。',
  PAYMENT_AUTH_CANCELLED: '你已取消微信授权，可以稍后继续支付。',
  PAYMENT_AUTH_EXPIRED: '支付授权已过期，请重新登录并在充值订单中继续支付。',
  PAYMENT_RETURN_ACCOUNT_MISMATCH: '此前付款属于另一个账号，请切回原账号查看。',
  PAYMENT_RETURN_EXPIRED: '支付返回已超时，请重新登录查看订单；已支付的订单仍会正常到账。',
  PAYMENT_PAYER_MISMATCH: '此订单已由另一微信账号授权，请使用原微信账号付款或关闭后重新下单。',
  PAYMENT_CANCELLED: '已取消本次支付，订单尚未付款，可以继续支付。',
  PAYMENT_BRIDGE_UNAVAILABLE: '未能调起微信支付，请在手机微信中重新打开本页。',
  PAYMENT_INVOKE_FAILED: '微信支付未完成，请查询订单状态后再试。',
  ORDER_ALREADY_PAID: '此订单已支付，请刷新余额，不要重复付款。',
  ORDER_EXPIRED: '此订单已过期，请关闭后重新选择套餐。',
  PAYMENT_MERCHANT_RESTRICTED: '商家微信收款功能被限制，暂时无法付款，请联系客服处理。',
  PAYMENT_PERMISSION_DENIED: '商家暂未获得此微信支付方式的权限，请联系客服处理。',
  PAYMENT_APP_MERCHANT_MISMATCH: '微信支付应用与商户配置不匹配，请联系管理员处理。',
  PAYMENT_SIGNING_CONFIG_ERROR: '微信支付签名配置异常，请联系管理员检查商户证书和私钥。',
  PAYMENT_REQUEST_INVALID: '微信未接受支付请求，请联系管理员检查支付配置。',
  PAYMENT_RESPONSE_UNVERIFIED: '暂时无法验证微信支付结果，请联系管理员检查微信支付公钥；如已付款，请勿重复支付。',
  PAYMENT_STATUS_UNKNOWN: '支付状态暂未确认，请继续原订单或稍后刷新，不要重复付款。',
  TOO_MANY_PENDING_ORDERS: '待支付订单较多，请先关闭不再支付的订单。',
}
export const paymentMessage = code => paymentMessages[code] || '支付暂未完成，请刷新订单状态后再试。'
export function paymentMode(agent = '', touchPoints = 0) {
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(agent) || /Macintosh/i.test(agent) && touchPoints > 1
  return !mobile ? 'NATIVE' : /MicroMessenger/i.test(agent) ? 'JSAPI' : 'H5'
}
export function parsePayment(value, expectedId) {
  const bad = () => { throw new AuthError('INVALID_RESPONSE') }
  if (!isRecord(value) || !isRecord(value.order) || !isUuid(value.order.id)
    || expectedId && value.order.id !== expectedId || !['PENDING', 'PAID', 'CLOSED'].includes(value.order.status)
    || !['NATIVE', 'H5', 'JSAPI', 'ALIPAY'].includes(value.mode)) bad()
  const checkedUrl = (value, host, path) => {
    try {
      const u = new URL(value)
      if (typeof value !== 'string' || value.length > 4096 || u.protocol !== 'https:' || u.hostname !== host || u.port || u.username || u.password || u.pathname !== path) bad()
    } catch (_) { bad() }
  }
  if (value.order.status === 'PAID') return value
  if (value.mode === 'ALIPAY') {
    try { const u = new URL(value.codeUrl); if (typeof value.codeUrl !== 'string' || value.codeUrl.length > 2048 || u.protocol !== 'https:' || u.hostname !== 'qr.alipay.com' || u.port || u.username || u.password || u.hash) bad() } catch (_) { bad() }
  } else if (value.mode === 'NATIVE') {
    if (typeof value.codeUrl !== 'string' || !value.codeUrl.startsWith('weixin://wxpay/') || value.codeUrl.length > 2048) bad()
  } else if (value.mode === 'H5') {
    checkedUrl(value.h5Url, 'wx.tenpay.com', '/cgi-bin/mmpayweb-bin/checkmweb')
  } else if (value.authorizationRequired) {
    checkedUrl(value.authorizationUrl, 'open.weixin.qq.com', '/connect/oauth2/authorize')
  } else {
    const p = value.jsapi
    if (!isRecord(p) || ['appId', 'timeStamp', 'nonceStr', 'package', 'signType', 'paySign'].some(k => typeof p[k] !== 'string' || !p[k] || p[k].length > 2048)
      || p.signType !== 'RSA' || !/^prepay_id=[A-Za-z0-9_-]+$/.test(p.package)) bad()
  }
  return value
}
export function invokeWechatPayment(parameters, win = window, doc = document) {
  return new Promise((resolve, reject) => {
    let started = false
    const clear = () => { clearTimeout(timer); doc.removeEventListener('WeixinJSBridgeReady', ready) }
    const ready = () => {
      if (started || !win.WeixinJSBridge || typeof win.WeixinJSBridge.invoke !== 'function') return
      started = true; clear()
      try {
        win.WeixinJSBridge.invoke('getBrandWCPayRequest', parameters, result => {
          if (result && result.err_msg === 'get_brand_wcpay_request:ok') resolve()
          else reject(new AuthError(result && result.err_msg === 'get_brand_wcpay_request:cancel' ? 'PAYMENT_CANCELLED' : 'PAYMENT_INVOKE_FAILED'))
        })
      } catch (_) { reject(new AuthError('PAYMENT_INVOKE_FAILED')) }
    }
    const timer = setTimeout(() => { clear(); reject(new AuthError('PAYMENT_BRIDGE_UNAVAILABLE')) }, 10000)
    doc.addEventListener('WeixinJSBridgeReady', ready)
    ready()
  })
}
